import { Button, Card, Form, InputNumber, Select, Typography } from 'antd'

import { InsulationPreparationRow } from './insulationPreparationModel'
import { InsulationPreparation } from './insulationPreparationTypes'

type Update = Partial<Omit<InsulationPreparation, 'sourceZoneId'>>

export const InsulationPreparationCard = ({
  row,
  readonly,
  onChange,
}: {
  row: InsulationPreparationRow
  readonly: boolean
  onChange: (sourceZoneId: string, update: Update) => void
}) => {
  const changeInsulation = (value: 'Yes' | 'No') =>
    onChange(row.sourceZoneId, { insulated: value === 'Yes' })
  const changeQuantity = (value: number | null) =>
    onChange(row.sourceZoneId, { plannedRemovalAreaM2: value ?? undefined })
  const useEstimate = () =>
    onChange(row.sourceZoneId, { plannedRemovalAreaM2: undefined })
  const planned = row.plannedRemovalAreaM2 ?? row.estimatedRemovalAreaM2
  return (
    <Card title={row.title} size='small'>
      <Form.Item
        label='Is this zone insulated?'
        htmlFor={`${row.sourceZoneId}-insulated`}
        required>
        <Select
          id={`${row.sourceZoneId}-insulated`}
          placeholder='Select Yes or No'
          value={
            row.insulated === undefined
              ? undefined
              : row.insulated
                ? 'Yes'
                : 'No'
          }
          options={[
            { value: 'Yes', label: 'Yes' },
            { value: 'No', label: 'No' },
          ]}
          disabled={readonly}
          onChange={changeInsulation}
        />
      </Form.Item>
      {row.insulated === true && (
        <>
          <Typography.Paragraph>
            Estimated minimum removal:{' '}
            {row.estimatedRemovalAreaM2 === undefined
              ? 'Not available from the source assessment'
              : `${row.estimatedRemovalAreaM2.toLocaleString(undefined, { maximumFractionDigits: 2 })} m²`}
          </Typography.Paragraph>
          <Form.Item
            label='Planned insulation removal (m²)'
            htmlFor={`${row.sourceZoneId}-removal-area`}
            required
            help={
              row.estimatedRemovalAreaM2 !== undefined &&
              planned !== undefined &&
              planned < row.estimatedRemovalAreaM2
                ? 'Below the source-based estimate. Check the site quantity.'
                : undefined
            }>
            <InputNumber
              id={`${row.sourceZoneId}-removal-area`}
              min={0}
              value={planned}
              disabled={readonly}
              onChange={changeQuantity}
            />
          </Form.Item>
          {row.plannedRemovalAreaM2 !== undefined &&
            row.estimatedRemovalAreaM2 !== undefined && (
              <Button disabled={readonly} onClick={useEstimate}>
                Use estimate
              </Button>
            )}
        </>
      )}
    </Card>
  )
}
